const Item = () => (
  <span className="mx-8 font-heading text-6xl md:text-8xl font-semibold sm-outline-text">
    Sales IP. Engineered.
    <span className="mx-8 text-teal/40">/</span>
  </span>
);

export const Marquee = () => (
  <section className="relative py-8 md:py-12 border-y border-white/[0.05] overflow-hidden" data-testid="marquee">
    <div className="sm-marquee-track">
      {Array.from({ length: 6 }).map((_, i) => (
        <Item key={i} />
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-navy to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-navy to-transparent" />
  </section>
);
